import { formatAsCurrency } from '~/util/textUtils';

export const getFacetFromPriceRange = (
  priceMinimum: number | undefined | null,
  priceMaximum: number | 'max' | undefined | null
) => {
  const priceMinimumDollars = priceMinimum ? formatAsCurrency(priceMinimum) : '';
  const priceMaximumDollars =
    priceMaximum && typeof priceMaximum === 'number' ? formatAsCurrency(priceMaximum) : '';

  if (priceMinimumDollars && priceMaximumDollars) {
    return {
      checked: true,
      displayName: `${priceMinimumDollars} - ${priceMaximumDollars}`,
      key: `price-${priceMinimum}-${priceMaximum}`,
      slug: `price-${priceMinimum}-${priceMaximum}`,
      tagName: `${priceMinimumDollars} - ${priceMaximumDollars}`,
      value: false,
    };
  }
  if (priceMinimumDollars) {
    return {
      checked: true,
      displayName: `Over ${priceMinimumDollars}`,
      key: `price-minimum-${priceMinimum}`,
      slug: `price-minimum-${priceMinimum}`,
      tagName: `Over ${priceMinimumDollars}`,
      value: false,
    };
  }
  if (priceMaximumDollars) {
    return {
      checked: true,
      displayName: `Up to ${priceMaximumDollars}`,
      key: `price-maximum-${priceMaximum}`,
      slug: `price-maximum-${priceMaximum}`,
      tagName: `Up to ${priceMaximumDollars}`,
      value: false,
    };
  }

  return null;
};
